module.exports = __webpack_public_path__ + "static/media/22PerformancePhotos.7009773a.jpeg";